module.exports = __webpack_public_path__ + "img/ch09_09_穿高跟鞋.15fdad3d.jpg";